module.exports = {"370702001":"城关街道","370702002":"南关街道","370702003":"西关街道","370702004":"北关街道","370702005":"于河街道","370702006":"望留街道","370702400":"潍城经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370702.json
// module id = 1530
// module chunks = 0